import { render } from "./NcrmLeadBoard.vue?vue&type=template&id=b96944ba&scoped=true"
import script from "./NcrmLeadBoard.vue?vue&type=script&lang=js"
export * from "./NcrmLeadBoard.vue?vue&type=script&lang=js"

import "./NcrmLeadBoard.styles.css?vue&type=style&index=0&id=b96944ba&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96944ba"]])

export default __exports__